import { useCallback, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { Wallet } from 'lucide-react'
import { useT } from '@/i18n'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { fetchWallets, type AdminWalletRow } from '@/lib/adapters'
import { PERMISSIONS } from '@/lib/permissions'

/**
 * A10.09 — Hamyonlar reytingi. GET /admin/wallets (backend `f5fe3cb`).
 * Balans = ichki Take token (BIGINT). Har hamyon → foydalanuvchi kartasiga havola.
 */
export function WalletsScreen() {
  const t = useT()

  const columns = useMemo<AdminColumn<AdminWalletRow>[]>(
    () => [
      {
        key: 'user',
        header: t.col.name,
        type: 'text',
        minWidth: 180,
        sortable: false,
        render: (r) => (
          <Link to={`/users/${r.user_id}/wallet`} className="text-accent hover:underline">
            {r.first_name || (r.username ? `@${r.username}` : `#${r.user_id}`)}
          </Link>
        ),
      },
      { key: 'username', header: t.col.username, type: 'text', width: 160 },
      {
        key: 'balance',
        header: t.finance.balance,
        type: 'number',
        width: 150,
        align: 'right',
        render: (r) => (
          <span className="block text-right font-mono tabular text-primary">
            {r.balance.toLocaleString()}
          </span>
        ),
      },
      { key: 'updated_at', header: t.finance.updated, type: 'date', width: 160 },
    ],
    [t],
  )

  const fetcher = useCallback(fetchWallets, [])

  return (
    <>
      <PageHeader title={t.finance.wallets} screenId="A10.09" />
      <DataTable<AdminWalletRow>
        screenId="A10.09"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.user_id)}
        exportable
        emptyState={{ icon: <Wallet size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
